import { React, Fragment, memo } from 'react'
import {
  BodyText,
  HeadingText,
  Card,
  Button,
  Container,
  Row,
  Col,
} from '@paypalcorp/pp-react'
import { PRIVACY_HOME } from '../../../constants/constants'
import { Message } from '@paypalcorp/worldready-react'
import serverData from '../../../utils/server-data'

const DARError = memo(() => {
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="requestForm-response-msg-header">
          <img
            className="requestForm-response-msg-image"
            alt="error"
            aria-hidden="true"
            src={`https://${serverData.cdnHostName}/paypal-ui/illustrations/svg/critical.svg`}
          />
        </div>

        <Row>
          <Col
            lg={{
              span: 8,
              offset: 2,
            }}
          >
            <Card className="requestForm-response-msg-title">
              <div className="text-center">
                <HeadingText id="darErrorHeader" size="sm">
                  <Message id="dar.section.error.heading" />
                </HeadingText>
              </div>
              <Card.Content>
                <BodyText className="text-center">
                  <Message id="dar.section.error.bodycontent" />
                </BodyText>
                <div className="requestForm-header-info">
                  <BodyText className="text-center">
                    <Message id="dar.section.error.tilecontent" />
                  </BodyText>
                </div>
              </Card.Content>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col
            md={{
              span: 8,
              offset: 2,
            }}
            lg={{
              span: 6,
              offset: 3,
            }}
          >
            <Button
              id="darErrorDoneBtn"
              data-testid ="darErrorBtn"
              className="requestForm-response-msg-btn"
              onClick={() => {
                location.href = PRIVACY_HOME
              }}
            >
              <Message id="dar.section.error.buttonlabel" />
            </Button>
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
})

DARError.displayName = 'DARError'

export default DARError
